/**
 * AgentOS-Zeichen „Werkstück“ (Entwurf B, von Alex am 06.10.2026 freigegeben,
 * Cloud-Marketing): ein Punkt in der Mitte, Striche auf einem Ring darum.
 * Kopie aus dem Portal (cloud-v2 `lib/agentOsZeichen.ts`, Stand 19be7de6),
 * damit der Anmeldeschirm dasselbe Zeichen trägt (Post #5421).
 *
 * Maße im Feld 100 × 100: Ring R = 37, Punkt r = 15, Strich 12,2 lang und
 * 8,5 breit mit runden Enden. Acht Striche, unter 40 px sechs.
 */
export const ZEICHEN_FARBEN = ['#4285F4', '#6E63FF', '#A142F4', '#EA4335', '#FA7B17', '#FBBC04'] as const
export const ZEICHEN_RING = 37
const ZEICHEN_MASSE = {
  8: { laenge: 12.2, breite: 8.5, punkt: 15 },
  6: { laenge: 16.27, breite: 11, punkt: 17 },
} as const

/** Strichlänge, Strichbreite und Punktradius im Feld 100 × 100. */
export function zeichenMasse(anzahl: 6 | 8 = 8): { laenge: number; breite: number; punkt: number } {
  return ZEICHEN_MASSE[anzahl]
}

export interface ZeichenStrich { x1: number; y1: number; x2: number; y2: number; farbe: string }

const hex = (n: number) => Math.round(n).toString(16).padStart(2, '0').toUpperCase()

/** Farbe an der Stelle t (0…1) des Verlaufs durch die sechs Markenfarben.
 *  Der Verlauf schließt sich nicht: der letzte Strich ist gelb, nicht wieder blau. */
export function zeichenFarbe(t: number): string {
  const pos = Math.min(1, Math.max(0, t)) * (ZEICHEN_FARBEN.length - 1)
  const i = Math.min(ZEICHEN_FARBEN.length - 2, Math.floor(pos))
  const f = pos - i
  const a = ZEICHEN_FARBEN[i], b = ZEICHEN_FARBEN[i + 1]
  const kanal = (o: number) => {
    const von = parseInt(a.slice(o, o + 2), 16), bis = parseInt(b.slice(o, o + 2), 16)
    return hex(von + (bis - von) * f)
  }
  return `#${kanal(1)}${kanal(3)}${kanal(5)}`
}

/** Die Striche im Uhrzeigersinn ab oben, jeder quer zum Radius. */
export function zeichenStriche(anzahl: 6 | 8 = 8): ZeichenStrich[] {
  const halb = zeichenMasse(anzahl).laenge / 2
  const rund = (n: number) => Math.round(n * 100) / 100
  return Array.from({ length: anzahl }, (_, i) => {
    const w = (-90 + (i * 360) / anzahl) * (Math.PI / 180)
    const mx = 50 + ZEICHEN_RING * Math.cos(w), my = 50 + ZEICHEN_RING * Math.sin(w)
    const tx = -Math.sin(w) * halb, ty = Math.cos(w) * halb
    return { x1: rund(mx - tx), y1: rund(my - ty), x2: rund(mx + tx), y2: rund(my + ty), farbe: zeichenFarbe(i / (anzahl - 1)) }
  })
}
